import { type PrimaryCategoryConstructor } from '@webapp/core/entities/internal/PrimaryCategory'
import { type LocationApiModel } from '../api-models/LocationApiModel'

export const mapLocation = (
  location: LocationApiModel
): PrimaryCategoryConstructor => ({
  id: location.id,
  name: location.name,
})
